var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdlIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.1vw",
    height: "1.1vw",
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.025,
    y: 0.525,
    width: 19.95,
    height: 19.95,
    rx: 9.975,
    stroke: "#FF3636",
    strokeWidth: 1.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.131 8.086V13H5.934V8.086H7.131ZM9.83945 8.086C10.3575 8.086 10.8101 8.18867 11.1975 8.394C11.5848 8.59933 11.8835 8.88867 12.0935 9.262C12.3081 9.63067 12.4155 10.0577 12.4155 10.543C12.4155 11.0237 12.3081 11.4507 12.0935 11.824C11.8835 12.1973 11.5825 12.4867 11.1905 12.692C10.8031 12.8973 10.3528 13 9.83945 13H7.99845V8.086H9.83945ZM9.76245 11.964C10.2151 11.964 10.5675 11.8403 10.8195 11.593C11.0715 11.3457 11.1975 10.9957 11.1975 10.543C11.1975 10.0903 11.0715 9.738 10.8195 9.486C10.5675 9.234 10.2151 9.108 9.76245 9.108H9.19545V11.964H9.76245ZM14.2814 12.076H15.8494V13H13.0844V8.086H14.2814V12.076Z",
    fill: "#FF3636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdlIcon);
export default __webpack_public_path__ + "static/media/IdlIcon.29511c72b77671fcdff091bb778b28da.svg";
export { ForwardRef as ReactComponent };